import React from "react";
import moment from "moment";

const GlobalContext = React.createContext({
  events: [],
  eventsExtremeDates: {},
  selectedDay: 1,
  selectedMonth: moment().month(),
  selectedYear: moment().year(),
  setSelectedDay: () => {},
  setSelectedMonth: () => {},
  setSelectedYear: () => {},
  DATE_FORMAT: 'YYYY-MM-DD',
  DAYS_TRANSLATIONS: [],
  MONTHS_TRANSLATIONS: [],
  EVENT_TYPE: {}
});

export default GlobalContext;

// periodical_report
// closed_period
// corporate_event
// normal
